/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Switch, Route } from 'react-router-dom';

import ProtectedRoute from './components/ProtectedRoute';
import MyAccount from './components/MyAccount';
import AccountLogin from './components/AccountLogin';

const Routes = () => (
    <>
        <Switch>
            <Route
                path="/account/gift-list/:id?"
                exact
                component={() => (
                    <MyAccount
                        page={{
                            account: true,
                        }}
                        module="GiftList"
                    />
                )}
            />
            <Route
                path="/account/orders/:uuid/:order?/:zip?/:status?"
                exact
                component={() => <MyAccount module="OrderDetails" />}
            />
            <Route
                path="/:lang([a-zA-Z]{2})/order-information/:uuid/:order?/:zip?/:status?"
                exact
                component={() => <MyAccount module="OrderDetails" />}
            />
            <Route
                path="/:lang([a-zA-Z]{2})/track-order"
                exact
                component={() => <MyAccount module="TrackOrder" />}
            />
            <Route
                path="/track-order"
                exact
                component={() => <MyAccount module="TrackOrder" />}
            />
            <Route
                path="/order-information/:uuid/:order/:email"
                exact
                component={() => <MyAccount module="OrderDetailsByEmail" />}
            />
            <ProtectedRoute
                path="/account/subscriptions"
                component={() => <MyAccount module="Subscriptions" />}
            />
            <ProtectedRoute
                path="/account/address-book"
                component={() => <MyAccount module="AddressBook" />}
            />
            <ProtectedRoute
                path="/account/billing-address"
                component={() => <MyAccount module="BillingAddress" />}
            />
            <ProtectedRoute
                path="/account/profile"
                component={() => <MyAccount module="ProfileAndPassword" />}
            />
            <ProtectedRoute
                path="/account/orders"
                component={() => <MyAccount module="OrderListing" />}
            />
            <ProtectedRoute
                path="/account/wishlist"
                component={() => <MyAccount module="WishlistComponent" />}
            />
            <ProtectedRoute
                path="/account/order/:orderNumber"
                component={() => <MyAccount module="OrderDetailsPLA" />}
            />
            <ProtectedRoute
                path="/account/change-password"
                component={() => <MyAccount module="ChangePassword" />}
            />
            <ProtectedRoute
                path="/account/change-email"
                component={() => <MyAccount module="ChangeEmail" />}
            />
            <ProtectedRoute
                path="/account/email-preference"
                component={() => <MyAccount module="EmailPreference" />}
            />
            <ProtectedRoute
                path="/account/passport"
                component={() => <MyAccount module="Passport" />}
            />
            <ProtectedRoute
                path="/account/login"
                component={() => <AccountLogin module="LoginForm" />}
            />
            <ProtectedRoute
                path="/account/reset-password"
                component={() => <AccountLogin module="ResetPasswordForm" />}
            />
            <ProtectedRoute
                path="/account/create-account"
                component={() => <AccountLogin module="CreateAccountForm" />}
            />
            <ProtectedRoute
                path="/account"
                component={() => <MyAccount module="AccountHome" />}
            />
        </Switch>
    </>
);

export default Routes;
